export const blockIconsHouseholdLightNew = (
	<span className='material-symbols-outlined'>light</span>
);
